import { useFileDownload } from '@Hooks/useFileDownload';
import { useDocumentsRepository } from '@Hooks/useRepository';
import { ArchivesRepository } from '@Repositories/Documents';
import { EnumMessageCode, isOk } from '@synqo/frontend-component-library';
import { useCallback } from 'react';

export type ArchiveOutcome = { ok: true } | { ok: false; gone: boolean; message?: string };

/** Downloads an archive through its short-lived storage link. `gone` tells an expired or missing archive apart. */
// @ai-generated 2026-10-02T08:34:30+00:00 by philipp.kammerer@synqony.com using Claude Opus 5.5 (1M context)
export function useArchiveDownload() {
    const archives = useDocumentsRepository(ArchivesRepository);
    const { triggerUrlDownload } = useFileDownload();

    return useCallback(
        async (archiveId: string): Promise<ArchiveOutcome> => {
            const result = await archives.download(archiveId);
            if (!result || !isOk(result)) {
                const messages = result?.messages ?? [];
                const gone = messages.some((message) => message.code === EnumMessageCode.DataDoesNotExist);
                return { ok: false, gone, message: messages[0]?.message };
            }

            triggerUrlDownload(result.data.download_url);
            return { ok: true };
        },
        [archives, triggerUrlDownload],
    );
}
